import React, { Component } from 'react';
import PropTypes from 'prop-types';
import loadable from '@loadable/component';
import {
	Container,
	Top,
	LogoLink,
	SearchWrapper,
	UserSpace,
	UserButtonWrapper,
} from './headerTopStyles';
import {
	OverlayTrigger,
} from 'core/components/FullMobileOverlay';

// Import icons individually for better code splitting
import BurgerIcon from 'core/icons/BurgerIcon';
import Logo from 'core/icons/Logo';

import SearchBar, { AmpSearchBar } from 'core/components/SearchBar';
import ShopBag from 'core/components/ShopBag';
import MarketingCta from './MarketingCta';
import MenuCta from './MenuCta';
import userProps from './userProps';
import { LoginBubble } from 'core/components/Login';
import Trigger from 'core/components/Login/LoginBubble/Trigger';
import { isEmpty } from 'core/utils/objectUtils';
import { ResponsiveCheck } from 'core/providers/Responsive';
// Loadables:
import UserIcon from 'core/icons/UserIcon';
const UserAccount = loadable(() => import('../UserAccount'), {
	fallback: <UserIcon stroke="currentColor" />
});

class HeaderTop extends Component {
	state = {
		clientSide: false
	}

	componentDidMount() {
		this.setState({ clientSide: true });
	}

	render () {
		const { amp, user, burgerId, cartCount, toggleBottomEnabled, searchEmptyState } = this.props;
		const { clientSide } = this.state;
		const noUser = isEmpty(user);
		const showBag = !amp && !noUser;
		return (
			<ResponsiveCheck>
				{({ isMobile }) => (
					<Container>
						<Top>
							{/* data-name used for automation test_homepage */}
							<LogoLink data-name="header-logo-link" href="/" title="Cratejoy - Shop Subscription Boxes">
								<Logo />
							</LogoLink>
							<SearchWrapper>
								{ clientSide
									? <SearchBar searchEmptyState={searchEmptyState} />
									: <AmpSearchBar />
								}
							</SearchWrapper>
							<MarketingCta />
							<UserSpace>
								<MenuCta />
								{showBag && <ShopBag cartCount={cartCount} toggleBottomEnabled={toggleBottomEnabled} />}
								<UserButtonWrapper id="marketplace-auth-button">
									{ !noUser
										? <UserAccount {...user} amp={amp} isMobile={isMobile} />
										: clientSide
											? <LoginBubble text="Sign in" />
											: <Trigger text="Sign in" as="a" href="/login" title="Sign in - Cratejoy" />
									}
								</UserButtonWrapper>
								{isMobile && (
									<OverlayTrigger triggerId={burgerId} marginLeft={24}>
										<BurgerIcon />
									</OverlayTrigger>
								)}
							</UserSpace>
						</Top>
					</Container>
				)}
			</ResponsiveCheck>
		);
	}

	static propTypes = {
		amp: PropTypes.bool,
		user: userProps,
		burgerId: PropTypes.string,
		cartCount: PropTypes.oneOfType([
			PropTypes.number,
			PropTypes.string,
		]),
		toggleBottomEnabled: PropTypes.func,
		searchEmptyState: PropTypes.array,
	}
}

export default HeaderTop;
